import script from "./ProductDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailView.vue?vue&type=style&index=0&id=3ce50d31&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce50d31"]])

export default __exports__